import React, { useState, createContext, useMemo, useEffect } from "react";

export const ChargebeeApiContext = createContext();

export const ChargebeeInstanceProvider = ({ children }) => {
  const [chargebeeInstanceLoaded, setChargebeeInstanceLoaded] = useState(false);

  useEffect(() => {
    const scriptId = 'chargebee-init';
    // Check if script is already loaded
    if (document.getElementById(scriptId)) {
      setChargebeeInstanceLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://js.chargebee.com/v2/chargebee.js';
    script.async = true;

    script.onload = () => {
      try {
        if (window.Chargebee) {
          window.Chargebee.init({
            site: process.env.REACT_APP_CHARGEBEE_SITE,
            publishableKey: process.env.REACT_APP_CHARGEBEE_PUBLISHABLE_KEY,
          });
          setChargebeeInstanceLoaded(true);
        }
      } catch (error) {
        console.error('Error initializing Chargebee:', error);
      }
    };

    script.onerror = () => {
      console.error('Failed to load Chargebee script');
      setChargebeeInstanceLoaded(false);
    };

    document.head.appendChild(script);
  }, []);

  const value = useMemo(() => ({
    chargebeeInstanceLoaded,
  }), [chargebeeInstanceLoaded]);

  return (
    <ChargebeeApiContext.Provider value={value}>
      {children}
    </ChargebeeApiContext.Provider>
  );
};
